<template>
	<div id="particles-js">
		<div class="login">
			<div class="login-top">
				登录
			</div>
			<div class="login-center clearfix">
				<div class="login-center-img"><img src="../assets/images/name.png" /></div>
				<div class="login-center-input">
					<input type="text" name="" v-model="username" placeholder="请输入您的用户名" onfocus="this.placeholder=''"
						onblur="this.placeholder='请输入您的用户名'" />
					<div class="login-center-input-text">用户名</div>
				</div>
			</div>
			<div class="login-center clearfix">
				<div class="login-center-img"><img src="../assets/images/password.png" /></div>
				<div class="login-center-input">
					<input type="password" name="" v-model="passwordstr" placeholder="请输入您的密码"
						onfocus="this.placeholder=''" onblur="this.placeholder='请输入您的密码'" />
					<div class="login-center-input-text">密码</div>
				</div>
			</div>
			<div class="login-button" @click="onLogin">
				登陆
			</div>
		</div>
		<div class="sk-rotating-plane"></div>
	</div>
</template>


<script>
	import login from '../assets/js/login.js'
	import loginapp from '../assets/js/loginapp.js'

	export default {
		components: {},
		data() {
			return {
				username: '',
				passwordstr: '',
				timer: ''
			}
		},
		update() {
			this.$router.go(0)
		},
		mounted() {
			let _this = this;
			
			this.$nextTick(() => {
				let username=this.$cookie.get("accounts");
				let password=this.$cookie.get("password");
				this.username=username;
				this.passwordstr=password;
				
				// var pJS_tag = document.getElementsByClassName('particles-js-canvas-el');
				// setTimeout(function() {
				// 	if (pJS_tag.length == 0) {
				// 		// window.particlesJS();
				// 	}
				// }, 500);

			})
		},
		methods: {
			onLogin: function() {
				let _this = this;
				this.$api.post('/login', {
						accounts: _this.username,
						password: _this.passwordstr
					},
					function(response, context) {
						if (response.code == "200") {
							let data = response.data;
							sessionStorage.setItem('Authorization', data.Authorization);
							sessionStorage.setItem('userName', '客户一');
							_this.$cookie.set("accounts",_this.username) 
							_this.$cookie.set("password",_this.passwordstr) 
							_this.$cookie.set("Authorization",data.Authorization) 
							_this.$cookie.set("username",'客户一') 
							_this.$router.push('/deviceList');
						} else {
							_this.$message({
								showClose: true,
								message: response.message,
								type: response.code == "200" ? 'success' : 'error'
							});
						}
					}
				);
			},
		},
		watch: {

		}
	}
</script>


<style lang="scss" scoped>
	@import '../assets/css/loginstyle.css';
</style>
